import axios from 'axios'

//Default values
const state = {}

const mutations = {}

const actions = {
    SAVE_MEASUREMENT: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'customers/' + payload.payload.customer_id + '/components/' + payload.payload.component_id + '/measurements', payload.form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    GET_MEASUREMENT: async ({commit}, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers/' + payload.customer_id + '/components/' + payload.component_id + '/measurements/' + payload.id)
            .then((res) => {
                commit('SET_SELECTED_TYPE', res.data.relations.component.component_type_id)
                return res.data
            })
    },
    GET_MEASUREMENTS: async ({rootState, commit}, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'measurements', {
            params: rootState.table.table.serverParams
        })
            .then((res) => {
                commit('FETCH_ITEMS', res.data)
            })
    },
    UPDATE_MEASUREMENT: async (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(process.env.VUE_APP_API_URL + 'customers/' + payload.payload.customer_id + '/components/' + payload.payload.component_id + '/measurements/' + payload.payload.id, payload.form)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    DELETE_MEASUREMENT: async ({commit}, payload) => {
        return axios.delete(process.env.VUE_APP_API_URL + 'customers/' + payload.customer_id + '/components/' + payload.component_id + '/measurements/' + payload.id)
            .then((res) => {
                return res.data
            })
    },
    GET_FILES: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_URL + 'measurements/' + payload.measurement_id + '/files')
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    SAVE_FILES: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'measurements/' + payload.measurement_id + '/files', payload.files,  {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    REMOVE_FILE: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.delete(process.env.VUE_APP_API_URL + 'measurements/' + payload.measurement_id + '/files/' + payload.id)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    APPROVE_MEASUREMENTS: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'measurements/approve', {ids: payload})
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
}

const getters = {}

export default {
    state,
    mutations,
    actions,
    getters
}
